module.exports = __webpack_public_path__ + "static/media/astron-github.b91a809c.png";